// 本地缓存key列表
export const JINSHA_KEYS = {
  lotteryType: "JINSHA_LOTTERY_TYPE_KEYS"
};

// 加密
function compileStr(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(c);
}

// 解密
function uncompileStr(code) {
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;
}

// set方法
export const setStorage = (key, data) => {
  let default_string = JSON.stringify(data);
  let default_complite = compileStr(default_string);
  localStorage.setItem(key, default_complite);
};

// get方法
export const getStorage = key => {
  let default_string = localStorage.getItem(key);
  if (default_string) {
    let default_unComplite = uncompileStr(default_string);
    return JSON.parse(default_unComplite);
  }
  return false;
};

export const setLocalLotteryType = data => {
  setStorage(JINSHA_KEYS.lotteryType, data);
};
export const getLocalLotteryType = () => {
  return getStorage(JINSHA_KEYS.lotteryType);
};



// WEBPACK FOOTER //
// ./src/utils/localStorageService.js